export const ADD = 'resource_add';
export const FIND_ALL = 'resource_find_all';
export const LOADING = 'resource_loading';
export const REMOVE = 'resource_remove';
export const SEARCH = 'resource_search';
export const UPDATE = 'resource_update';

export const resourceTypes = {
  ADD,
  FIND_ALL,
  LOADING,
  REMOVE,
  SEARCH,
  UPDATE,
};
